<app-custom-selector [(ngModel)]="rate" #custom="ngModel" [max]="10">
</app-custom-selector>

<div>touched: {{ custom.touched }}</div>
<div>parent component: {{ rate }}</div>
<br />
<br />
<br />
<br />

<app-table-input
  [(ngModel)]="timetable"
  [rowLabels]="tableRowLabels"
  [colLabels]="tableColLabels"
  [rows]="7"
  [cols]="24"
>
</app-table-input>

{{ timetable | json }}
